import { render, staticRenderFns } from "./CFilter.vue?vue&type=template&id=5fa97c2c&"
import script from "./CFilter.vue?vue&type=script&lang=js&"
export * from "./CFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports